import css from './NavMenu.css'
import { on, ready, queryAll } from '../../lib/dom.js'

ready(function () {
  disableLinks();
})

on('click', '#page-shop-payment .NavMenu > thead > tr > th.done a', function(event){
  event.preventDefault();
  return false;
})

export function disableLinks(){
  var NavMenuLinks = queryAll('.NavMenu th:not(.done):not(.active) a');
  if(NavMenuLinks.length>0){
    for(var i=0; i<NavMenuLinks.length;++i){
      NavMenuLinks[i].classList.add('disabled');
    }
    return true;
  }
  return false;
}

export function enableLinks(){
  var NavMenuLinks = queryAll('.NavMenu th:not(.done):not(.active) a.disabled');
  if(NavMenuLinks.length>0){
    for(var i=0; i<NavMenuLinks.length;++i){
      NavMenuLinks[i].classList.remove('disabled');
    }
    return true;
  }
  return false;
}